/**
 * Footer.jsx
 *
 * Footer de l'application avec :
 * - Liens Discord
 * - Crédit @altered-online
 * - Liens utiles
 * - Design Ant Design
 */

import React from "react";
import { Layout, Row, Col, Space, Button } from "antd";
import { DiscordOutlined, GithubOutlined, HeartOutlined } from "@ant-design/icons";
import { useTheme } from "../../context/ThemeContext";

const { Footer: AntFooter } = Layout;

export default function Footer() {
    const { isDarkMode } = useTheme();

    const currentYear = new Date().getFullYear();

    return (
        <AntFooter
            style={{
                background: isDarkMode ? "#141414" : "#fafafa",
                borderTop: `1px solid ${isDarkMode ? "#434343" : "#d9d9d9"}`,
                marginTop: "48px",
            }}
        >
            <div style={{ maxWidth: "1200px", margin: "0 auto" }}>
                <Row gutter={[32, 32]}>
                    {/* Section 1 : À propos */}
                    <Col xs={24} sm={12} md={6}>
                        <h4 style={{ marginBottom: "16px" }}>À propos</h4>
                        <Space direction="vertical" style={{ width: "100%" }}>
                            <p style={{ margin: 0, fontSize: "14px" }}>
                                Tracker de prix pour cartes Altered
                            </p>
                            <p style={{ margin: 0, fontSize: "12px", opacity: 0.7 }}>
                                Suivez les variations de prix en temps réel
                            </p>
                        </Space>
                    </Col>

                    {/* Section 2 : Liens */}
                    <Col xs={24} sm={12} md={6}>
                        <h4 style={{ marginBottom: "16px" }}>Liens</h4>
                        <Space direction="vertical" style={{ width: "100%" }}>
                            <Button
                                type="text"
                                href="https://www.altered.gg"
                                target="_blank"
                                rel="noreferrer"
                                style={{ padding: 0, fontSize: "14px" }}
                            >
                                Site Altered.gg
                            </Button>
                            {/*<Button*/}
                            {/*    type="text"*/}
                            {/*    href="https://discord.gg/altered"*/}
                            {/*    target="_blank"*/}
                            {/*    rel="noreferrer"*/}
                            {/*    style={{ padding: 0, fontSize: "14px" }}*/}
                            {/*>*/}
                            {/*    Discord Officiel*/}
                            {/*</Button>*/}
                        </Space>
                    </Col>

                    {/* Section 3 : Communauté */}
                    <Col xs={24} sm={12} md={6}>
                        <h4 style={{ marginBottom: "16px" }}>Communauté</h4>
                        <Space size="middle">
                            <Button
                                type="text"
                                icon={<DiscordOutlined />}
                                href="https://discord.gg/M8mRDVrhCM"
                                target="_blank"
                                rel="noreferrer"
                                size="large"
                            />
                            {/*<Button*/}
                            {/*    type="text"*/}
                            {/*    icon={<GithubOutlined />}*/}
                            {/*    href="https://github.com"*/}
                            {/*    target="_blank"*/}
                            {/*    rel="noreferrer"*/}
                            {/*    size="large"*/}
                            {/*/>*/}
                        </Space>
                    </Col>

                    {/* Section 4 : Crédit */}
                    <Col xs={24} sm={12} md={6}>
                        <h4 style={{ marginBottom: "16px" }}>Crédit</h4>
                        <Space direction="vertical" style={{ width: "100%" }}>
                            <p style={{ margin: 0, fontSize: "14px", display: "flex", alignItems: "center", gap: "4px" }}>
                                Fait avec <HeartOutlined style={{ color: "#ff4d4f" }} /> par
                            </p>
                            {/*<Button*/}
                            {/*    type="text"*/}
                            {/*    href="https://twitter.com/altered_online"*/}
                            {/*    target="_blank"*/}
                            {/*    rel="noreferrer"*/}
                            {/*    style={{ padding: 0, fontSize: "14px", fontWeight: "600" }}*/}
                            {/*>*/}
                                @Drest
                            {/*</Button>*/}
                        </Space>
                    </Col>
                </Row>

                {/* Ligne de séparation */}
                <div style={{ borderTop: `1px solid ${isDarkMode ? "#434343" : "#d9d9d9"}`, margin: "24px 0" }} />

                {/* Copyright */}
                <Row justify="center">
                    <Col>
                        <p style={{ margin: 0, fontSize: "12px", opacity: 0.6 }}>
                            © {currentYear} Altered-checker. Tous droits réservés.
                        </p>
                    </Col>
                </Row>
            </div>
        </AntFooter>
    );
}